module.exports = __webpack_public_path__ + "static/media/fondo_header.b0be7493.jpeg";